import PersonalAccount from 'core/components/PersonalAccount';


function Profile() {
  return <PersonalAccount />;
}

export default Profile;
